import { render, staticRenderFns } from "./ContextMenuSimple.vue?vue&type=template&id=838794e4&"
import script from "./ContextMenuSimple.vue?vue&type=script&lang=js&"
export * from "./ContextMenuSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports